var table_viewer_default = {
  "viewMode": "z2lC7",
  "editMode": "E8Q2k",
  "container": "JKAgW",
  "cell": "_5bJWt"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
